<script>
export default {
	lang: 'account',
	props: {
		order: Object,
	},
	data() {
		return {
			loading: false,
			paymentData: null,
			error: false,
		}
	},
	methods: {
		payOrder() {
			this.$shopApi.post(`/order/${this.order.id}/resolve-payment`, {
				loading: (v) => (this.loading = v),
				onSuccess: ({ data, options }) => {
					if (data.embedFormInCheckout && data.paymentData) {
						this.paymentData = data.paymentData
					} else if (data.initPoint) {
						options.redirect(data.initPoint)
					} else {
						this.error = true
					}
				},
				onError: () => {
					this.error = true
				},
			})
		},
		async paymentConfirmed() {
			window.location.reload()
		},
	},
}
</script>

<template>
	<div>
		<div v-if="error">
			<div
				class="font-2 error--text text-center"
				v-html="$lang('Ha ocurrido un error al cargar el formulario de pago.')"
			></div>
		</div>
		<div v-else-if="!paymentData">
			<div
				class="font-2"
				v-html="
					$lang(
						'Para realizar el pago, <b>haz click en el siguiente botón</b> Si ya realizaste el pago demorará unos minutos en procesarse'
					)
				"
			></div>
			<div class="py-5">
				<Button color="success" :loading="loading" @click="payOrder">
					{{ 'Pagar con Talo' | lang }}
				</Button>
			</div>
		</div>
		<TaloTransferInfo
			v-else
			:payment-data="paymentData"
			:order-id="order.id"
			@payment-confirmed="paymentConfirmed"
		/>
	</div>
</template>

